import script from "./statics.vue?vue&type=script&setup=true&lang=js"
export * from "./statics.vue?vue&type=script&setup=true&lang=js"

import "./statics.vue?vue&type=style&index=0&id=46377e56&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46377e56"]])

export default __exports__